export const extraQueryParams = {
  backgroundImageUrl:
    'https://syntheticdatastorageprod-cdn-hpgkdta8a7eehggt.z02.azurefd.net/cache/music-crew.png',
};
